export enum KeyboardKeyConstant {
  ENTER = "Enter",
  TAB = "Tab",
  BACKSPACE = "Backspace",
}
